import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import './SideDrawer.css';

const SideDrawer = (props) => {
  const nodeRef = useRef(null); // Create ref for DOM node

  const content = (
    <CSSTransition
      in={props.show}
      timeout={200}
      classNames="slide-in-left"
      mountOnEnter
      unmountOnExit
      nodeRef={nodeRef} // Pass nodeRef here (Pass the ref to the transition)
    >
      <aside ref={nodeRef} className="side-drawer" >{props.children}</aside>
    </CSSTransition>
  );

  return ReactDOM.createPortal (content, document.getElementById ('drawer-hook'));
};

export default SideDrawer;